import React from "react";
import "./ratereviewbox.css";

const Ratereviewbox = ({ review = [] }) => {
  return (
    <div className="review-section">
      <div className="review-title">Customer Reviews</div>
      <div className="review-list">
        {review.map((r, index) => {
          const hasComment = r.commands?.trim();
          const hasImage =
            r.review_images &&
            r.review_images !== "null" &&
            r.review_images !== "";
          const imageUrl = hasImage
            ? `${process.env.REACT_APP_BASEURL}/apis/customer/uploads/reviews/${r.review_images}`
            : null;

          return (
            <div key={index} className="review-card">
              {!hasComment && hasImage && (
                <img
                  src={imageUrl}
                  alt="review"
                  className="review-stamp left"
                />
              )}

              <div className="review-header">
                <div className="reviewer-name">
                  {r.customer_name || "Anonymous"}
                </div>
                <div className="review-date">{r.create_date}</div>
              </div>
              <div className="review-content">
                <span>
                  <div className="review-stars">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <span
                        key={i}
                        className={
                          i < Number(r.rating) ? "star filled" : "star"
                        }
                      >
                        ★
                      </span>
                    ))}
                  </div>

                  {hasComment && (
                    <div className="review-text">“{r.commands}”</div>
                  )}
                </span>

                {hasComment && hasImage && (
                  <img
                    src={imageUrl}
                    alt="review"
                    className="review-stamp right"
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Ratereviewbox;
